const namespaced = true

const state = {
    user: {}
}

const getters = {
    getUser: state => state.user,
}

const mutations = {
    SET_USER: (state, user) => {
        state.user = user
    }
}

const actions = {
    setUser: ({commit}, user) => {
        commit('SET_USER', user)
    }
}

export const user = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}
